module.exports = __webpack_public_path__ + "static/1-encryption-in-general-d81c3b654a042508e70356c893a8b0e4.jpg";